import axios from 'axios';
// import types from './cityTypes';

import { toastr } from "react-redux-toastr";

import { BASE_API, USER_TOKEN } from '../../../../config/consts';
// import { initializeForm, reset } from "../../../../helpers/redux";
import { errors2String } from '../../../../helpers/utils';
import { getListFiltered as getMyCharts } from '../myCharts/myChartsActions';
import types from './homeTypes';
import { setLoading } from '../../../../helpers/redux';
import { dateFormat2Show } from '../../../../helpers/dataTransformers';

const URL = `${BASE_API}/charts`;

/**
 * Função que serve para trazer todos os mapas cadastradas sem paginação
 * @returns {Object} Evento com a Promise da requisição. o redux-promise irá
 * tratar de resolver a Promise antes de atualizar o reducer
 */
export const drawChart = (values, action_type) => {
    return (dispatch) => {
        const newValues = {
            ...values,
            date: values.birthday
        }
        if(newValues.city) {
            axios.post(`${URL}/draw`, newValues, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(localStorage.getItem(USER_TOKEN)).token}`
                }
            }).then((response) => {
                dispatch(
                    {
                        type: 'BIRTH_'+action_type,
                        payload: values
                    }
                );
                dispatch(
                    {
                        type: action_type,
                        payload: {data: {content: {...response.data.content, data: {...values, type: 'Mapa Natal'}}}}
                    }
                );
                
            }).catch((err) => {
                try {
                    const errors = errors2String(err.response.data.content.errors);
                    dispatch({ type: 'ERROR_DRAW_CHART'});
                    toastr.error('Erro!', errors);
                } catch (error) {
                    dispatch({ type: 'ERROR_DRAW_CHART'});
                    toastr.error('Erro!', 'Erro no servidor, favor verificar a politica de CORS');
                    console.log(err);
                }
            });
        } else {
            window.location.href = '/#/meus-mapas';
            toastr.warning('Aviso!', `O mapa ${values.name} não foi cadastrado com uma cidade válida. Por favor atualize o mesmo para que possa ser mostrado`);

        }
    }
}

export const chartToPrint = (value) => {
    return (dispatch) => {
        dispatch({
            type: types.CHART_TO_PRINT,
            payload: value
        })
    }
}

/**
 * Função que serve para trazer todos os mapas cadastradas sem paginação
 * @returns {Object} Evento com a Promise da requisição. o redux-promise irá
 * tratar de resolver a Promise antes de atualizar o reducer
 */
export const saveChart = (values) => {
    return (dispatch) => {
        const newValues = {
            ...values,
            date: values.birthday
        }
        axios.post(`${URL}`, newValues, {
            headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem(USER_TOKEN)).token}`
            }
        }).then((response) => {
            const fields = "name,person_name,hour,daylight_savings,birthday,city.lat,city.lon,city.timezone,houses"
            dispatch(setLoading(types.HOME_LOADING, true));
            dispatch(getMyCharts(values.user, fields, 'limit=999999'));
            dispatch(drawChart({...response.data.content, city: values.city}, types.CHART_DRAWN_BOTH))
            toastr.success('Sucesso', 'O mapa foi cadastrado com sucesso!');
        }).catch((err) => {
            try {
                const errors = errors2String(err.response.data.content.errors);
                dispatch({ type: 'ERROR_DRAW_CHART'});
                toastr.error('Erro!', errors);
            } catch (error) {
                dispatch({ type: 'ERROR_DRAW_CHART'});
                toastr.error('Erro!', 'Erro no servidor, favor verificar a politica de CORS');
                console.log(err);
            }
        });
    }
}

/**
 * Função que serve para trazer todos os mapas cadastradas sem paginação
 * @returns {Object} Evento com a Promise da requisição. o redux-promise irá
 * tratar de resolver a Promise antes de atualizar o reducer
 */
export const drawSolarRevolution = (values, action_type) => {
    return (dispatch) => {
        const newValues = {
            ...values,
            date: values.birthday
        }
        axios.post(`${URL}/draw/solar-return`, newValues, {
            headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem(USER_TOKEN)).token}`
            }
        }).then((response) => {
            const { dateReturn } = response.data.content;
            dispatch({
                type: action_type,
                payload: {data: {content: {...response.data.content, data: {...values, dateReturn, type: `Revolução Solar ${values.year}`}}}}
            });
        }).catch((err) => {
            try {
                const errors = errors2String(err.response.data.content.errors);
                dispatch({ type: 'ERROR_DRAW_CHART'});
                toastr.error('Erro!', errors);
            } catch (error) {
                dispatch({ type: 'ERROR_DRAW_CHART'});
                toastr.error('Erro!', 'Erro no servidor, favor verificar a politica de CORS');
                console.log(err);
            }
        });
    }
}

/**
 * Função que serve para trazer todos os mapas cadastradas sem paginação
 * @returns {Object} Evento com a Promise da requisição. o redux-promise irá
 * tratar de resolver a Promise antes de atualizar o reducer
 */
export const drawMoonRevolution = (values, action_type) => {
    return (dispatch) => {
        const newValues = {
            ...values,
            date: values.birthday
        }
        axios.post(`${URL}/draw/moon-return`, newValues, {
            headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem(USER_TOKEN)).token}`
            }
        }).then((response) => {
            const { dateReturn } = response.data.content;
            dispatch({
                type: action_type,
                payload: {data: {content: {...response.data.content, data: {...values, dateReturn, type: `Revolução Lunar ${dateFormat2Show(dateReturn.date,'/')}`}}}}
            });
        }).catch((err) => {
            try {
                const errors = errors2String(err.response.data.content.errors);
                dispatch({ type: 'ERROR_DRAW_CHART'});
                toastr.error('Erro!', errors);
            } catch (error) {
                dispatch({ type: 'ERROR_DRAW_CHART'});
                toastr.error('Erro!', 'Erro no servidor, favor verificar a politica de CORS');
                console.log(err);
            }
        });
    }
}

export const drawTransits = (values, action_type) => {
    return (dispatch) => {
        const newValues = {
            ...values,
            date: values.birthday
        }
        axios.post(`${URL}/transits`, newValues, {
            headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem(USER_TOKEN)).token}`
            }
        }).then((response) => {
            dispatch({
                type: action_type,
                payload: {data: {content: {...response.data.content, data: {...values, type: `Trânsitos Diretos ${values.year}`}}}}
            });
        }).catch((err) => {
            try {
                const errors = errors2String(err.response.data.content.errors);
                dispatch({ type: 'ERROR_DRAW_CHART'});
                toastr.error('Erro!', errors);
            } catch (error) {
                dispatch({ type: 'ERROR_DRAW_CHART'});
                toastr.error('Erro!', 'Erro no servidor, favor verificar a politica de CORS');
                console.log(err);
            }
        });
    }
}


